import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import settings from 'configs/settings';
import clg from './log';

/**
 * @description Overrides the PUSH and REPLACE methods in history to
 * save the window scroll position for the route.
 *
 * @param { Object } scrollData - Contains pathname and its scroll position.
 */
const useScrollMemory = (scrollData) => {
  const history = useHistory();

  useEffect(() => {
    const { push, replace } = history;

    // Override the history PUSH method to automatically set scroll state.
    history.push = (path, state = {}) => {
      scrollData[history.location.pathname] = window.scrollY;
      push(path, state);
    };

    // Override the history REPLACE method to automatically set scroll state.
    history.replace = (path, state = {}) => {
      scrollData[history.location.pathname] = window.scrollY;
      replace(path, state);
    };

    // Listen for location changes and set the scroll position accordingly.
    const unregister = history.listen((location, action) => {
        if( location.state !== "filterChange" ) { //! Filter változások esetén ne történjen görgetés
          if( action === "POP" && scrollData[location.pathname] ) {
              setTimeout(() => {
                  window.scrollTo({
                          top: scrollData[location.pathname],
                          behavior : 'smooth'
                      }
                  );
              }, settings.router.animationDurationOnRouteChange * 100 + 500);
          }

          if( action !== "POP" ) {
              window.scrollTo({
                  top: 0,
                  left: 0,
                  behavior : 'smooth'
              });
          }
        }
    });

    // Unregister listener when component unmounts.
    return () => {
      unregister();
    };
  }, [history]); //history
};

export default useScrollMemory;